<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="save"  :loading="btnLoading">保存</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div>
      <el-form :model="cv" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="单位编号">
              <el-input v-model="cv.cvcode" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="单位名称">
              <el-input v-model="cv.cvname" :maxlength="128" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="单位类型">
              <el-select v-model="cv.cvtype" :clearable="true" :disabled="disable">
                <el-option v-for="(item, index) in cvtypeList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="7">
            <el-form-item label="联系人">
              <el-input v-model="cv.cvcontact" :maxlength="128" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="联系电话">
              <el-input v-model="cv.cvtel" :maxlength="128" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="联系地址">
              <el-input v-model="cv.cvaddr" :maxlength="128" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="单位简述">
              <el-input v-model="cv.cvremark" :maxlength="255" type="textarea" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "cvform",
    data () {
      return {
        cv: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        cvtypeList: []
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getCvtypeList()
    },
    watch: {
    },
    filters: {
    },
    methods: {
      async init() {
        this.cv = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.cvtypeList = []
      },
      async getCvtypeList () {
        this.cvtypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'cvtype'}
        })
      },
      async save () {
        this.btnLoading = true
        let model = {
          insertRecords: [],
          updateRecords: [],
          removeRecords: []
        }
        this.cv.cvcomid = this.$store.getters.loginUser.usercomid
        if (this.cv.cvid === 0) {
          model.insertRecords = [this.cv]
        } else {
          model.updateRecords = [this.cv]
        }
        await this.addOrEdit(model)
        this.btnLoading = false
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0 && model.updateRecords.length === 0 && model.removeRecords.length ===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/basic/cv/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'cvIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
